import LMSForum from "@/models/lms/LMSForum";
import LMSForumTopic from "@/models/lms/LMSForumTopic";
import LMSForumPost from "@/models/lms/LMSForumPost";

import Router from "@/router/index";

export const ForumModule = {
    namespaced: true,
    state: {
        forum: {},
        errors: [],
        topics: [],
        openTopic: {},
        hasLoaded: false,
        expandForumDropdown: false,
        chosenForumId: null,
        gettingData: false,
        chosenTopicId: null,
        chosenPostId: null,
        chosenCommentId: null,
        chosenPost: {
            id: false,
        },
    },

    getters: {},
    mutations: {
        //synchronous
        TOGGLE_FORUM_DROPDOWN(state) {
            state.expandForumDropdown = !state.expandForumDropdown;
        },
        SET_FORUM_DROPDOWN(state, payload) {
            state.expandForumDropdown = payload;
        },
        SET_LOADED(state, payload) {
            state.hasLoaded = payload;
        },
        SET_ERRORS: (state, errors) => {
            state.errors = errors;
        },
        SET_FORUM: (state, forum) => {
            state.forum = forum;
        },
        SET_TOPICS(state, payload) {
            state.topics = payload;
        },
        SET_OPEN_TOPIC(state, payload) {
            state.openTopicId = payload;
        },
        REMOVE_OPEN_TOPIC(state, payload) {
            if (state.openTopics.includes(payload)) {
                state.openTopics.splice(state.openTopics.indexOf(payload));
            } else {
                return;
            }
        },
    },

    actions: {
        openTopic({commit}, payload) {
            commit("SET_OPEN_TOPIC", payload);
        },
        closeTopic({commit}, payload) {
            commit("REMOVE_OPEN_TOPIC", payload);
        },
        async GET_FORUM({commit, state}, payload) {
            commit("SET_LOADED", false);
            return LMSForum.getForum(payload)
                .then(async function (res) {
                    await commit("SET_FORUM", res.data.forum);
                    await commit("GET_TOPICS", state.forum.id);
                })
                .catch(function () {
                })
                .then(() => {
                    commit("SET_LOADED", true);
                });
        },
        async GET_TOPICS({commit}, forumId) {
            commit("SET_LOADED", false);
            return LMSForum.FetchById(forumId, ["topics"])
                .then(async function (res) {
                    let topics = [];
                    const topicsUnrefined = res.response.data.data.attributes.topics;
                    for (const topicIndex in topicsUnrefined) {
                        topics[topicIndex] = Object.assign(
                            topicsUnrefined[topicIndex],
                            topicsUnrefined[topicIndex].attributes
                        );
                    }
                    await commit("SET_TOPICS", topics);
                })
                .catch(function () {
                })
                .then(() => {
                    commit("SET_LOADED", true);
                });
        },
        GET_FORUM_NEW_VERSION({commit, dispatch, state}, forumId) {
            commit("SET_LOADED", false);
            this.dispatch("loader/show", "Loading forum");
            LMSForumTopic.deleteAll();
            return LMSForum.FetchById(forumId)
                .then(async function (res) {
                    if (res.response.data.data) {
                        await commit("SET_FORUM", res.response.data.data);
                        await dispatch("GET_TOPICS", state.forum.id);
                    }

                    this.dispatch("loader/hide");
                })
                .catch(() => {
                    commit("SET_LOADED", true);
                    this.dispatch("loader/hide");
                });
        },
        ADD_POST_TO_TOPIC({dispatch}, payload) {
            return LMSForumPost.addPost(payload)
                .then(function (res) {
                    dispatch("ADD_POST_TO_DOCUMENT", res.data.data);
                })
                .catch(function () {
                });
        },
    },
};
